import { DataBean } from "../DataBean";

export class FunctionalAreaToEmployee extends DataBean {


    public async setFunctionalAreaToEmployeeContract(idContract:any,fromDate:any,idLnFunctionalArea:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "employees.EmployeeContract_setFunctionalAreaToEmployeeContract_Number_java.util.Date_Number_Number", [idContract,fromDate,idLnFunctionalArea,idEmployee]);
    }
   

    

 
}